import { Button } from 'antd';
import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
`;

export const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: baseline;
  padding: 10px 0;
  align-items: flex-start;
  .ant-btn {
    padding: 0 !important;
  }

  @media (min-width: ${({ theme }) => theme.mediaQueries.sm}) {
    gap: 20px;
    align-items: center;
    flex-direction: row;

    .ant-btn {
      padding: 4px 12px !important;
    }
  }
`;

export const BoldWrapper = styled.div`
  font-weight: 600;
`;

export const CustomButton = styled(Button)`
  overflow-wrap: break-word;
  white-space: normal;
  font-size: 12px;

  @media (min-width: ${({ theme }) => theme.mediaQueries.sm}) {
    max-width: 400px;
    width: 100%;
    padding: 5px 0;
    & span {
      text-align: right;
      width: 100%;
    }
  }
`;
